(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pw-product-experience"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.pwProductExperience) return;
    window.pwProductExperience = true;
    const viewport = window.visualViewport;
    let viewportFrame = 0;
    let lastBottomOffset = '';
    const syncViewportBottom = () => {
      viewportFrame = 0;
      const canTrack = viewport && viewport.height > 0 && window.innerWidth < 750 && Math.abs(viewport.scale - 1) <= 0.01;
      const bottomOffset = canTrack
        ? Math.max(0, window.innerHeight - viewport.height - Math.max(0, viewport.offsetTop))
        : 0;
      const value = `${Math.ceil(bottomOffset)}px`;
      if (value === lastBottomOffset) return;
      lastBottomOffset = value;
      document.documentElement.style.setProperty('--pw-viewport-bottom-offset', value);
    };
    const scheduleViewportBottom = () => {
      if (!viewportFrame) viewportFrame = requestAnimationFrame(syncViewportBottom);
    };
    viewport?.addEventListener('resize', scheduleViewportBottom, { passive: true });
    viewport?.addEventListener('scroll', scheduleViewportBottom, { passive: true });
    viewport?.addEventListener('scrollend', scheduleViewportBottom, { passive: true });
    window.addEventListener('resize', scheduleViewportBottom, { passive: true });
    window.addEventListener('scroll', scheduleViewportBottom, { passive: true });
    window.addEventListener('pageshow', scheduleViewportBottom);
    document.addEventListener('dialog:open', scheduleViewportBottom, true);
    syncViewportBottom();
    const states = new WeakMap();
    const visibleChoices = new WeakMap();
    const labels = () => document.querySelector('[data-pw-product-ui]')?.dataset || {};
    const rootFor = (node) => node?.closest('#quick-add-modal-content, [data-product-grid-content]') || node?.closest('.shopify-section')?.querySelector('[data-product-grid-content]');
    const stateFor = (root) => {
      const config = root?.querySelector('[data-pw-product-config]');
      if (!config) return null;
      let state = states.get(root);
      if (!state || state.source !== config.textContent) {
        try {
          const data = JSON.parse(config.textContent);
          state = { data, source: config.textContent, sizes: state?.data.id === data.id ? state.sizes : new Map() };
          states.set(root, state);
        } catch { return null; }
      }
      return state;
    };
    const isSize = (input) => /size/i.test(input?.dataset.optionName || '');
    const sizeGroups = (root) => [...root.querySelectorAll('variant-picker fieldset')].filter((group) => isSize(group.querySelector('input[data-option-name]')) && group.querySelectorAll('input').length > 1);
    const showFit = (root) => {
      if (root.closest('quick-add-dialog')) {
        const link = root.querySelector('.pw-product-full-details');
        if (link) {
          const url = new URL(link.href);
          url.searchParams.set('fit', '1');
          window.location.assign(url.href);
        }
        return;
      }
      const details = root.querySelector('[data-pw-details]');
      if (!details) return;
      details.open = true;
      details.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      details.querySelector('summary')?.focus({ preventScroll: true });
    };
    const syncVisualOptions = (root) => {
      for (const group of root.querySelectorAll('.pw-visual-option')) {
        const selected = group.querySelector('input:checked');
        const label = group.querySelector('[data-pw-selected-option]');
        if (selected && label && label.textContent !== selected.value) label.textContent = selected.value;
        if (!selected) continue;
        const row = group.querySelector('.pw-visual-option__row');
        const choice = selected.closest('.pw-visual-option__choice');
        const selectionKey = `${group.closest('variant-picker')?.dataset.productId}:${selected.value}`;
        if (!row || !choice || !row.clientWidth || visibleChoices.get(group) === selectionKey) continue;
        const rowBounds = row.getBoundingClientRect();
        const choiceBounds = choice.getBoundingClientRect();
        if (choiceBounds.left < rowBounds.left + 3) row.scrollLeft += choiceBounds.left - rowBounds.left - 3;
        else if (choiceBounds.right > rowBounds.right - 3) row.scrollLeft += choiceBounds.right - rowBounds.right + 3;
        visibleChoices.set(group, selectionKey);
      }
    };
    const enhance = (root) => {
      syncVisualOptions(root);
      const state = stateFor(root);
      if (!state) return;
      root.dataset.pwEnhanced = 'true';
      for (const group of sizeGroups(root)) {
        const inputs = [...group.querySelectorAll('input[data-option-name]')];
        const name = inputs[0].dataset.optionName;
        const selected = inputs.find((input) => input.checked);
        const explicit = state.sizes.get(name);
        const pending = !explicit || selected?.value !== explicit;
        group.dataset.pwAwaitingSize = String(pending);
        if (pending) {
          state.sizes.delete(name);
          for (const input of inputs) {
            input.checked = false;
            input.dataset.currentChecked = 'false';
            input.dataset.previousChecked = 'false';
          }
        }
        const legend = group.querySelector('legend');
        if (legend && !legend.querySelector('[data-pw-fit]')) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pw-size-guide-button';
          button.dataset.pwFit = '';
          button.textContent = labels().sizeGuide;
          legend.append(button);
        }
        if (legend && !legend.querySelector('.pw-size-hint')) {
          const hint = document.createElement('span');
          hint.className = 'pw-size-hint';
          legend.append(hint);
        }
        const hint = legend?.querySelector('.pw-size-hint');
        if (hint) {
          const text = pending ? labels().chooseSize : '';
          if (hint.textContent !== text) hint.textContent = text;
          hint.hidden = !pending;
        }
      }
      for (const details of root.querySelectorAll('[data-pw-description] > details')) {
        details.querySelector(':scope > summary')?.remove();
        details.replaceWith(...details.childNodes);
      }
      const form = root.querySelector('product-form-component');
      if (form && !root.querySelector('.pw-option-error')) {
        const error = document.createElement('p');
        error.className = 'pw-option-error';
        error.setAttribute('role', 'alert');
        error.hidden = true;
        form.before(error);
      }
    };
    const validate = (root) => {
      const state = stateFor(root);
      if (!state) return true;
      enhance(root);
      const missing = sizeGroups(root).find((group) => group.dataset.pwAwaitingSize === 'true');
      if (!missing) return true;
      const error = root.querySelector('.pw-option-error');
      if (error) { error.textContent = labels().sizeError; error.hidden = false; }
      missing.scrollIntoView({ block: 'center', behavior: 'instant' });
      const control = missing.querySelector('input:not([aria-disabled="true"])') || missing.querySelector('input');
      control?.focus({ preventScroll: true });
      return false;
    };
    const chooseSize = (input) => {
      if (!isSize(input)) return;
      const root = rootFor(input);
      const state = stateFor(root);
      if (!state) return;
      state.sizes.set(input.dataset.optionName, input.value);
      const group = input.closest('fieldset');
      if (group) group.dataset.pwAwaitingSize = 'false';
      const error = root.querySelector('.pw-option-error');
      if (error) error.hidden = true;
    };
    window.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const fit = event.target.closest('[data-pw-fit]');
      if (fit) { event.preventDefault(); showFit(rootFor(fit)); return; }
      const input = event.target.matches('input[data-option-name]') ? event.target : null;
      if (input && event.isTrusted) chooseSize(input);
      const button = event.target.closest('product-form-component button[type="submit"], sticky-add-to-cart button');
      if (button && !validate(rootFor(button))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    window.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement) {
        if (event.isTrusted) chooseSize(event.target);
        const root = rootFor(event.target);
        if (root) syncVisualOptions(root);
      }
      schedule();
    }, true);
    window.addEventListener('submit', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('product-form-component')) return;
      if (!validate(rootFor(event.target))) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    document.addEventListener('pw:quick-add-ready', () => {
      const root = document.getElementById('quick-add-modal-content');
      if (!root) return;
      states.delete(root);
      enhance(root);
    });
    let scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        document.querySelectorAll('[data-product-grid-content], #quick-add-modal-content').forEach(enhance);
      });
    }
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
    if (new URLSearchParams(window.location.search).get('fit') === '1') {
      requestAnimationFrame(() => {
        const root = document.querySelector('[data-product-grid-content]');
        if (root) showFit(root);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pw-session-timer"] && !Shopify.designMode) return;
  try {
    (() => {
    const tick = () => {
      document.querySelectorAll('[data-pw-sale-countdown]').forEach(clock => {
        const deadline = Date.parse(clock.dataset.deadline);
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const time = clock.querySelector('[data-pw-sale-time]');
        const label = clock.querySelector('[data-pw-sale-label]');
        if (!time || !label) return;
        if (!Number.isFinite(remaining) || remaining === 0) {
          time.hidden = true;
          time.textContent = '';
          label.textContent = clock.dataset.endedText;
          clock.dataset.expired = 'true';
          return;
        }
        const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
        const minutes = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        time.textContent = `${hours}:${minutes}:${seconds}`;
        time.hidden = false;
      });
    };
    tick();
    setInterval(() => { if (!document.hidden) tick(); }, 1000);
    document.addEventListener('visibilitychange', tick);
    document.addEventListener('shopify:section:load', tick);
    document.addEventListener('shopify:section:select', tick);
  })();
  } catch(e) { console.error(e); }
})();

})();
